var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      staticClass: "supervised-person-manager-modal",
      attrs: { size: "tiny", closable: false },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c(
        "sui-modal-header",
        { staticClass: "supervised-person-manager-modal-header" },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      ),
      _c(
        "sui-modal-content",
        [
          _c(
            "sui-form",
            [
              _c(
                "sui-form-field",
                [
                  _c("label", [_vm._v("Firm")]),
                  _c("sui-dropdown", {
                    attrs: {
                      selection: "",
                      search: "",
                      direction: "downward",
                      placeholder: "Search Firms...",
                      options: _vm.firmOptions,
                    },
                    model: {
                      value: _vm.firmModel.firm,
                      callback: function ($$v) {
                        _vm.$set(_vm.firmModel, "firm", $$v)
                      },
                      expression: "firmModel.firm",
                    },
                  }),
                ],
                1
              ),
              _c(
                "sui-form-field",
                [
                  _c("label", [_vm._v("Investment Model")]),
                  _c("sui-dropdown", {
                    attrs: {
                      selection: "",
                      search: "",
                      direction: "downward",
                      placeholder: "Search Models...",
                      options: _vm.models,
                    },
                    model: {
                      value: _vm.firmModel.investment_model,
                      callback: function ($$v) {
                        _vm.$set(_vm.firmModel, "investment_model", $$v)
                      },
                      expression: "firmModel.investment_model",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "sui-modal-actions",
        [
          _c("sui-button", {
            attrs: {
              basic: "",
              size: "small",
              color: "grey",
              type: "button",
              content: "Cancel",
            },
            on: { click: _vm.cancel },
          }),
          _c("sui-button", {
            attrs: {
              primary: "",
              size: "small",
              type: "button",
              content: "Save",
            },
            on: { click: _vm.handleSave },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }